// Runs ASAP to prevent crashes when localStorage/sessionStorage are blocked
(function ensureSafeWebStorage() {
  try {
    const k = '__ls_test__';
    window.localStorage.setItem(k, '1');
    window.localStorage.removeItem(k);
    // Storage is available — nothing to do
  } catch (e) {
    // Provide an in-memory shim so any storage access doesn't crash the app
    const mem = new Map();
    const shim = {
      getItem(key)      { return mem.has(String(key)) ? mem.get(String(key)) : null; },
      setItem(key, val) { mem.set(String(key), String(val)); },
      removeItem(key)   { mem.delete(String(key)); },
      clear()           { mem.clear(); },
      key(i)            { return Array.from(mem.keys())[i] ?? null; },
      get length()      { return mem.size; }
    };

    try {
      Object.defineProperty(window, 'localStorage',   { value: shim, configurable: true });
      Object.defineProperty(window, 'sessionStorage', { value: shim, configurable: true });
      // Optional: visible in dev consoles
      // eslint-disable-next-line no-console
      console.warn('localStorage/sessionStorage blocked — using in-memory shim.');
    } catch {
      // If defineProperty is locked down, other code should still use safeStorage try/catch.
      // eslint-disable-next-line no-console
      console.warn('Storage blocked and not patchable; relying on safeStorage wrappers.');
    }
  }
})();
